/* eslint-disable @repo/internal/styles/no-nested-styles */

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import Button from '@atlaskit/button/custom-theme-button';
import { gridSize as getGridSize } from '@atlaskit/theme/constants';
import { DEFAULT_APPEARANCE } from './constants';
import { getActionBackground, getActionColor, getFlagFocusRingColor } from './theme';
var gridSize = getGridSize();
var separatorWidth = gridSize * 2;
var defaultAppearanceTranslate = gridSize / 4;
var separatorStyles = css({
  display: 'inline-block',
  width: separatorWidth,
  textAlign: 'center'
});
var actionContainerStyles = css({
  display: 'flex',
  paddingTop: gridSize,
  alignItems: 'center',
  flexWrap: 'wrap',
  transform: "translateX(-".concat(defaultAppearanceTranslate, "px)")
});
var boldActionContainerStyles = css({
  transform: 0
});
var buttonStyles = css({
  '&&, a&&': {
    marginLeft: 0,
    padding: "0 ".concat(gridSize, "px !important"),
    background: "var(--bg-color)",
    color: "var(--color) !important",
    fontWeight: 500
  },
  '&&:focus, a&&:focus': {
    boxShadow: "0 0 0 2px var(--focus-color)"
  },
  '&&:hover, &&:active, a&&:hover, a&&:active': {
    textDecoration: 'underline'
  }
});
var appeanceNormalButtonStyles = css({
  '&&, a&&': {
    padding: '0 !important'
  }
});
var isBoldButtonStyles = css({
  '&&, a&&': {
    marginRight: gridSize
  }
});

var FlagActions = function FlagActions(props) {
  var _props$appearance = props.appearance,
      appearance = _props$appearance === void 0 ? DEFAULT_APPEARANCE : _props$appearance,
      _props$actions = props.actions,
      actions = _props$actions === void 0 ? [] : _props$actions,
      linkComponent = props.linkComponent,
      mode = props.mode,
      testId = props.testId;

  if (!actions.length) {
    return null;
  }

  var isBold = appearance !== DEFAULT_APPEARANCE;
  return jsx("div", {
    css: [actionContainerStyles, isBold && boldActionContainerStyles],
    "data-testid": testId && "".concat(testId, "-actions")
  }, actions.map(function (action, index) {
    return [index && !isBold ? jsx("div", {
      css: separatorStyles,
      key: index + 0.5
    }, "\xB7") : '', jsx(Button, {
      onClick: action.onClick,
      href: action.href,
      target: action.target,
      appearance: isBold ? 'default' : 'link',
      component: linkComponent,
      spacing: "compact",
      testId: action.testId,
      key: index,
      style: {
        '--color': getActionColor(appearance, mode),
        '--bg-color': getActionBackground(appearance, mode),
        '--focus-color': getFlagFocusRingColor(appearance, mode)
      },
      css: [buttonStyles, isBold && isBoldButtonStyles, appearance === 'normal' && appeanceNormalButtonStyles]
    }, action.content)];
  }));
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc


export default FlagActions;